import React, { Component } from 'react';
import classNames from 'classnames';

import './styles.css';
/**
 * A reusable YouTube component.
 *
 * @typedef {Object} Props
 * @prop {String} videoId
 * @prop {Boolean} isToggled
 * @prop {String} [className]
 *
 * @extends {Component<Props>}
 */

export default class YouTubePlayer extends Component {
	state = {
		autoplay: 1,
	};

	// checks for isToggled prop and rerenders
	componentDidUpdate (prevProps) {
		if (this.props.isToggled !== prevProps.isToggled && !this.props.isToggled) {
			this.stopVideo();
		}
	}

	videoRef = React.createRef();

	genClassName = (props) => classNames('YouTubePlayer', props.className);
	// stops the video, and makes autoplay 0
	stopVideo = () => {
		const iframe_tag = this.videoRef.current;
		if (iframe_tag) {
			const iframeSrc = iframe_tag.src;
			iframe_tag.src = iframeSrc;
		}
		this.setState({ autoplay: 0 });
	};
	render () {
		return (
			<iframe
				ref={this.videoRef}
				allow='autoplay; encrypted-media'
				allowFullScreen
				className={this.genClassName(this.props)}
				frameBorder='0'
				src={`https://www.youtube.com/embed/${this.props.videoId}?rel=0&showinfo=0&autoplay=${this.state.autoplay}`}
				title={`YouTube video ${this.props.videoId}`}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/atoms/YouTubePlayer/YouTubePlayer.js